import { apiClient } from "@api/apiClient";

import { GetAxisRoleResponse } from "./axisRole.interface";

const API_ENDPOINT = {
  get: (draftArticleId: number) =>
    `/des/article-content/partner-axis-name/${draftArticleId}`,
};

export const axisRoleApis = {
  get: async (draftArticleId: number) => {
    const { data } = await apiClient.get<GetAxisRoleResponse>(
      API_ENDPOINT.get(draftArticleId),
    );
    return data;
  },
};
